import React, { useReducer, useEffect } from "react";

import AlertContext from "./AlertContext";
import AlertReducer from "./AlertReducer";
//import data from "../../data/projects.json";

import {
  SHOW_ALERT,
  SHOW_SNACKBAR,
  CLEAR_ALERT,
  SHOW_CONFIRMATION,
} from "../../data/constants";

const AlertStore = (props) => {
  //const localState = window.localStorage.getItem("jsi-intelli-project");

  const initialState = {
    message: "",
    title: "Info",
    messageType: "success",
    ui: "dialog",
    show: false,
    alertType: "information",
    submitAction: undefined,
  };
  const [state, dispatch] = useReducer(AlertReducer, initialState);

  useEffect(() => {
    if (state.show && state.ui === "snack") {
      setTimeout(() => {
        clearAlert();
      }, 3000);
    }
  }, [state.show, state.ui]);

  const showAlert = (message, title, alertType) => {
    // console.log("Search for", search);
    const payload = {
      message,
      title: title ? title : "Info",
      alertType: alertType ? alertType : "information",
      show: true,
    };
    console.log("SHOW_ALERT", payload);
    dispatch({
      type: SHOW_ALERT,
      payload,
    });
  };

  const showSnackbar = (message, messageType) => {
    // console.log("Search for", search);
    const payload = {
      message,
      messageType: messageType ? messageType : "success",
      show: true,
    };
    console.log("SHOW_SNACKBAR", payload);
    dispatch({
      type: SHOW_SNACKBAR,
      payload,
    });
  };

  const showConfirmation = (message, title, submitAction) => {
    const payload = {
      message,
      title: "Confirmation",
      alertType: "warning",
      messageType: "warning",
      show: true,
      submitAction,
    };
    console.log("SHOW_CONFIRMATION", payload);
    dispatch({
      type: SHOW_CONFIRMATION,
      payload,
    });
  };

  const clearAlert = () => {
    console.log("CLEAR_ALERT", initialState);
    dispatch({
      type: CLEAR_ALERT,
      payload: initialState,
    });
  };

  return (
    <AlertContext.Provider
      value={{
        ...state,
        showAlert,
        clearAlert,
        showSnackbar,
        showConfirmation,
      }}
    >
      {props.children}
    </AlertContext.Provider>
  );
};

export default AlertStore;
